import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientWEISSForm() {
    return (
        <PatientFormTemplate formTitle="Your Life Impact" />
    );
}
